import React, { useState, useEffect } from "react";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import axios from 'util/axios';


const AsyncSelectUnit = (props) => {
    const {
        api,
        body,
        onChange,
        value,
        label,
        name = "",
        search = true,
        textAlign = "left",
        arrow = false,
        isTable = false,
        placeholder = "Search...",
        placeholderTextAlign = "left",
        isDisabled = false,
        border = false,
        isTable2 = false,
        height = null
    } = props;
    const customStyle = {
        option: (provided, state) => ({
            ...provided,
            paddingLeft: "4px",
            textAlign: textAlign,
            // minHeight: "30px",
            width: "100%",
            color: state.isDisabled ? "#CCC" : "#000",
            backgroundColor: state.isFocused ? "#EEEEFF" : "#FFF",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#555",
            textAlign: textAlign,
            fontSize: isTable ? "12px" : isTable2 ? "16px" : "inherit",
            whiteSpace: "initial",
            // paddingLeft: "4px"
        }),
        menu: (provided, state) => ({
            ...provided,
            width: "max-content",
            minWidth: "100%",
            fontSize: isTable2 ? "16px" : null,
            zIndex: 20,
            backgroundColor: "#FFF",
        }),
        control: (provided, state) => ({
            ...provided,
            border: border === "ON" ? null : "none",
            backgroundColor: "transparent",
            boxShadow: "none",
            minHeight: "initial",
            height: height,
            // height: border === "ON" ? "38px" : "null"
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            padding: "0",
        }),
        placeholder: (provided, state) => ({
            ...provided,
            textAlign: placeholderTextAlign,
            paddingRight: "5px",
            color: state.isDisabled ? "transparent" : "#CCC",
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            display: arrow ? null : "none",
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            display: "none",
        }),
    }



    const [_options, _SetOptions] = useState([]);
    const [isKeyIn, setIsKeyIn] = useState(-1);

    const apiCall = async () => {

        const response = await axios.post(process.env.REACT_APP_API + api, body).then(Response => Response.data.data.result);
        const keyin = response?.filter(f => f.unitType === 1)
        setIsKeyIn(keyin.length);
        return response;
    }
    const onFocusFunc = async () => {

        const res = await apiCall();
        _SetOptions(res);
    }

    useEffect(() => {
        onFocusFunc();
    }, [props.body])


    if (isKeyIn > 0) {
        return <CreatableSelect
            // onFocus={onFocusFunc}
            className={"searchable-dropdown"}
            classNamePrefix={"searchable-dropdown"}
            styles={customStyle}
            name={name}
            value={value ? { value: value, label: label || value } : null}
            onChange={onChange}
            options={_options.map(f => ({ ...f, isDisabled: f.unitType === 1 }))}
            isDisabled={isDisabled}
            placeholder={placeholder}
            noOptionsMessage={() => "Loading..."}

        />
    } else if (isKeyIn > -1) {
        return <Select

            className={"searchable-dropdown"}
            classNamePrefix={"searchable-dropdown"}
            styles={customStyle}
            name={name}
            value={!!value ? { value: value, label: !!label ? label : value } : null}
            onChange={onChange}
            options={_options}
            isDisabled={isDisabled}
            isSearchable={search}
            placeholder={placeholder}
            noOptionsMessage={() => "Loading..."}

        />
    } else {
        return null
    }


}
export default AsyncSelectUnit